import React, { Component } from "react";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTheme } from "../../actions/themeActions";

class index extends Component {
  componentDidMount() {
    this.props.getTheme();
  }

  render() {
    const { theme, children } = this.props;

    return <div className={`app ${theme}`}>{children}</div>;
  }
}

index.propTypes = {
  theme: PropTypes.string.isRequired,
  getTheme: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme
});

export default connect(
  mapStateToProps,
  { getTheme }
)(index);
